import { useState } from "react";
import { IOnTimeDocumentPerMonth } from "../../../api/OnTimeDocumentPerMonth/OnTimeDocumentPerMonth.types";
import NumberUtils from "../../../utils/number.utils";
import WidgetNivoBase from "../Widget.nivo.base";
import Tooltips from "../../common/Tooltips/Tooltips";
import Toggler from "../../common/Toggler/Toggler";
import "./styles.scss";

interface Props {
  data?: IOnTimeDocumentPerMonth[]
}

function OnTimeDocumentPerMonth({ data }: Props) {
  const [checked, setChecked] = useState(true);

  function getData() {
    if (data) {
      if (checked) {
        return data.sort((a, b) => {
          const aDate = new Date(Number(a.year), Number(a.month) - 1, 1);
          const bDate = new Date(Number(b.year), Number(b.month) - 1, 1);
          return aDate.getTime() - bDate.getTime();
        })
        .map((item: IOnTimeDocumentPerMonth) => ({
          "date": `${item.month}/${item.year}`,
          "Late": Number(item.lateCount),
          "After Arrival": Number(item.extremelyLateCount),
          "On Time": Number(item.onTimeCount),
          "Early": Number(item.earlyCount)
        }))
      } else {
        return [
          {
            id: "Late",
            data: data.map((item: IOnTimeDocumentPerMonth) => {
              const { lateCount, totalCount, year, month } = item;
              const date = `${month}/${year}`;
              const percentage = (parseInt(lateCount) / parseInt(totalCount)).toFixed(4);

              return {
                x: date,
                y: percentage
              }
            })
          },
          {
            id: "After Arrival",
            data: data.map((item: IOnTimeDocumentPerMonth) => {
              const { extremelyLateCount, totalCount, year, month } = item;
              const date = `${month}/${year}`;
              const percentage = (parseInt(extremelyLateCount) / parseInt(totalCount)).toFixed(4);

              return {
                x: date,
                y: percentage
              }
            })
          },
          {
            id: "On Time",
            data: data.map((item: IOnTimeDocumentPerMonth) => {
              const { onTimePercentage, year, month } = item;
              const date = `${month}/${year}`;
              const percentage = Number(onTimePercentage).toFixed(4);

              return {
                x: date,
                y: percentage
              }
            })
          },
          {
            id: "Early",
            data: data.map((item: IOnTimeDocumentPerMonth) => {
              const { earlyCount, totalCount, year, month } = item;
              const date = `${month}/${year}`;
              const percentage = (parseInt(earlyCount) / parseInt(totalCount)).toFixed(4);

              return {
                x: date,
                y: percentage
              }
            })
          }
        ]
      }
    }
  };

  return (
    <div className="ontime-document-per-month">
      {checked ? (
        <WidgetNivoBase.Bar
          title={
            <Tooltips
              label={
                <>
                  <span>Dates are in Actual Departure Date</span>
                  <span><b>Packet Sent Date:</b> oeUploadHeader_hist.PacketSentDate</span>
                  <span><b>Extremely Late</b> - Packet Sent Date is 7days after departure and container has arrived</span>
                  <span><b>Late</b> - Packet Sent Date is 7days after departure and container has not arrived</span>
                  <span><b>On Time</b> - Packet Sent Date is 7days before arrival</span>
                </>
              }
              children="On Time Document Per Month"
            />
          }
          data={getData()}
          keys={["On Time", "Early","Late", "After Arrival"]}
          indexBy="date"
          marginBottom={50}
          axisLeftName="# Shipments"
          axisBottomName=""
          axisBottomRotation={-45}
          groupMode="stacked"
          colors={{ scheme: "set2" }}
          formatValue={v => NumberUtils.toShortened(v, 2)}
          legends={[
            {
              dataFrom: "keys",
              anchor: "bottom",
              direction: "row",
              itemWidth: 70,
              itemHeight: 12,
              itemsSpacing: 8,
              symbolShape: "circle",
              symbolSize: 12,
              toggleSerie: true,
              translateX: 0,
              translateY: 50
            },
          ]}
          tooltip={({ id, value, color, data }) => (
            <div className="tooltip-panel" style={{ color }}>
              <div>Total: <strong>{NumberUtils.numberWithCommas(Object.keys(data).filter(key => key !== "date").reduce((sum, key) => sum + data[key], 0))}</strong></div>
              <div>{id}: <strong>{NumberUtils.numberWithCommas(value)}</strong></div>
            </div>
          )}
          toggler={<Toggler label="Total" checked={checked} toggleChart={(v) => setChecked(v)} />}
        />
      ) : (
        <WidgetNivoBase.Line
          title={
            <Tooltips
              label={
                <>
                  <span>Dates are in Actual Departure Date</span>
                  <span><b>Packet Sent Date:</b> oeUploadHeader_hist.PacketSentDate</span>
                  <span><b>Extremely Late</b> - Packet Sent Date is 7days after departure and container has arrived</span>
                  <span><b>Late</b> - Packet Sent Date is 7days after departure and container has not arrived</span>
                  <span><b>On Time</b> - Packet Sent Date is 7days before arrival</span>
                </>
              }
              children="On Time Document Per Month"
            />
          }
          data={getData()}
          marginBottom={50}
          yFormat=" ~%"
          curve="monotoneX"
          colors={{ scheme: "set1" }}
          axisLeftName="# Shipments"
          axisBottom={{
            tickSize: 3,
            tickPadding: 3,
            tickRotation: -45,
            legend: '',
            legendOffset: 36,
            legendPosition: 'middle'
          }}
          formatYAxis={v => NumberUtils.toShortened(v * 100, 2)}
          enableGridX={false}
          legends={[
            {
              dataFrom: "keys",
              anchor: "bottom",
              direction: "row",
              itemWidth: 70,
              itemHeight: 12,
              itemsSpacing: 8,
              symbolShape: "circle",
              symbolSize: 12,
              toggleSerie: true,
              translateX: 0,
              translateY: 50
            },
          ]}
          toggler={<Toggler label="Percentage" checked={checked} toggleChart={(v) => setChecked(v)} />}
        />
      )}
    </div>
  )
}

export default OnTimeDocumentPerMonth;
